/**
 * @date 2020/11/02
 * @decs 神策数据埋点
 * @author zhangkai
 */
import sa from './plugin/sensorsdata.es6.min.js';
import Log from '../base/createLogger'
import { getUserId } from '@/utils/utils'

class Sensors {
    static OPTIONS = {
        'development': {
            server_url: 'https://sensorsdata.61info.cn/sa?project=hll_zhibo_test'
        },
        'test': {
            server_url: 'https://sensorsdata.61info.cn/sa?project=hll_zhibo_test'
        },
        'preprod': {
            server_url: 'https://sensorsdata.61info.cn/sa?project=hll_zhibo_test'
        },
        'production': {
            server_url: 'https://sensorsdata.61info.cn/sa?project=hll_zhibo_production'
        }
    }
    static initSuccess = false
    static presetProperties = ''
    static anonymousID = ''

    sensors = null
    $Sensors = null

    constructor() {
        Log.debug('sensors version', { sa });
        this.initES6();
    }

    initES6() {
        let self = this;
        if (sa) {
            Log.debug('当前埋点环境===>', process.env.NODE_ENV, '------>', process.env.REACT_APP_MODE)
            const saInitOptions = {
                server_url: Sensors.OPTIONS[process.env.REACT_APP_MODE].server_url,
                name: '$Sensors',
                show_log: process.env.NODE_ENV !== 'production' || true,
                use_client_time: false, //使用服务器时间
                max_string_length: 500, //发送字符串最大长度，默认为500
                send_type: 'image', // 'image' 'ajax' 和 'beacon',
            }
            sa.init(saInitOptions)
            sa.quick('isReady', function () {
                Sensors.initSuccess = true;
                Sensors.presetProperties = sa.getPresetProperties(); // 页面地址，页面标题，前向地址，SDK 类型及版本，屏幕宽高
                Sensors.anonymousID = sa.quick('getAnonymousID'); // 获取匿名ID
                // Log.debug('神策获取的页面信息', { info: { Sensors } });
                self.$Sensors = sa;
                // 注册公共属性
                sa.registerPage({
                    is_login: true,
                    platform_type: 'H5',
                    product_type: '学生端',
                    user_type: function () {
                        return window.sessionStorage.getItem('userType') || '未知'
                    },
                    other_version: ''
                })
            })
        }
        self.startAuthTrack();

        const userId = getUserId()
        if (userId) {
            this.toggleDistinctID(userId)
            this.$Sensors.login(userId);
        } else if (window.sessionStorage.getItem('deviceId')) {
            this.toggleDistinctID(window.sessionStorage.getItem('deviceId'))
        }
    }

    toggleDistinctID(id) {
        if (this.isEmpty()) {
            return;
        }
        if (id) {
            this.$Sensors.identify(id, true);
            Log.debug('设置DistinctID====>', id)
        }

    }

    /**
     * @param {Boobean} isReset
     *      true 直接设置，如果存在就覆盖
     *      false 如果不存在则设置，存在就不设置
     */
    setTrackAttribute(options, callback = null, isReset = true) {
        if (this.isEmpty()) {
            return;
        }
        let fn = isReset ? 'setProfile' : 'setOnceProfile';
        if (sa._.isFunction(callback)) {
            this.$Sensors[fn](options, callback)
        } else {
            this.$Sensors[fn](options, function (params) {
                Log.debug('用户属性添加回调', params)
            })
        }
    }

    appendProfile(options, callback = null) {
        if (this.isEmpty()) {
            return;
        }
        if (sa._.isFunction(callback)) {
            this.$Sensors.appendProfile(options, callback)
        } else {
            this.$Sensors.appendProfile(options, function (params) {
                Log.debug('数组属性添加值回调', params)
            })
        }
    }

    send(enentName, options = {}, callback = null) {
        if (this.isEmpty()) {
            return;
        }
        if ('eventName' in options) {
            delete options.eventName
        }
        if (sa._.isFunction(callback)) {
            this.$Sensors.track(enentName, Object.assign({}, options), callback)
        } else {
            this.$Sensors.track(enentName, options, function (params) {
                Log.debug('手动埋点的回调', params)
            })
        }
    }

    isEmpty() {
        if (!this.$Sensors) {
            this.initES6();
            Log.error('神策对象调用失败')
            return true;
        }
        return false;
    }

    loginPageAuthTrack(eltarget) {
        Log.debug('登录页埋点', { eltarget })
        this.$Sensors.quick('autoTrackSinglePage');
    }

    startAuthTrack() {
        this.$Sensors.quick('autoTrack')
    }
}

export const SA = Sensors
export default new Sensors()